import SelectMultipleInput from './SelectMultipleInput';
import './SelectMultipleInput.scss';
export default SelectMultipleInput;
